import { Injectable, EventEmitter } from "@angular/core";

import { Counter } from "@models/counter";
import { ExperiencesService } from "./experiences.service";

export enum Experience {
  ACTIVE = "activeVersionsCount",
  EXPIRED = "expiredVersionsCount",
  PENDING_APPROVAL = "pendingVersionsCount",
  DRAFT = "draftVersionsCount",
  REJECTED = "rejectedVersionsCount",
}

export enum Operation {
  INCREASING,
  DECREASING,
}

@Injectable({
  providedIn: "root",
})
export class ExperienceCountService {
  public count = new EventEmitter<Counter>();
  private counter: Counter = null;

  constructor(private experienceSvc: ExperiencesService) {}

  sendCount(countExp: Counter) {
    this.count.emit(countExp);
  }

  changeCount(experience: Experience, operation: Operation) {
    if (this.counter !== null && experience !== null && operation !== null) {
      if (operation === Operation.INCREASING) {
        this.counter[experience]++;
      } else if (operation === Operation.DECREASING) {
        this.counter[experience]--;
      }

      this.sendCount(this.counter);
    }
  }

  setCount(countExp: Counter) {
    this.counter = countExp;
  }
}
